import {
  type ComponentPropsWithoutRef,
  type FC,
  type PropsWithChildren,
  useMemo,
} from 'react';

import {
  getNavCategoriesFromFsCache,
  navCategoriesDataFetcher,
} from '../../utils/fs-cache/nav-categories-cache';
import { LulNavbar } from '../LulNavbar';
import MainFooter from '../MainFooter';

import PageHead, { type PageHeadProps } from './PageHead';
import {
  type LayoutNavCategoryListingFragment,
  useLayoutHeaderDataQuery,
} from './__generated-gql-types__/Layout.generated';

type Props = PropsWithChildren<
  PageHeadProps & ComponentPropsWithoutRef<typeof LulNavbar>
> & {
  hideAnnouncementBanner?: boolean;
};

export type LayoutDataProps = ComponentPropsWithoutRef<
  typeof LulNavbar
>['pageContentData'];

export const getStaticLayoutQuery = async (): Promise<LayoutDataProps> => {
  let navCategoryListings: LayoutNavCategoryListingFragment[];
  try {
    navCategoryListings = await getNavCategoriesFromFsCache();
  } catch {
    navCategoryListings = (await navCategoriesDataFetcher()).navCategories;
  }
  return { navCategoryListings };
};

const useLayoutDataQuery = (): LayoutDataProps => {
  const { data } = useLayoutHeaderDataQuery();

  return useMemo(
    () => ({
      navCategoryListings: data?.navCategories ?? [],
    }),
    [data],
  );
};

const Layout: FC<Props> = ({
  children,
  pageContentData,
  hideAnnouncementBanner,
  ...pageHeadProps
}) => {
  const clientPageContentData = useLayoutDataQuery();

  const pageContentDataToUse = clientPageContentData?.navCategoryListings.length
    ? clientPageContentData
    : pageContentData;
  return (
    <>
      <PageHead {...pageHeadProps} />

      {/* BODY */}
      <div className="flex flex-col-reverse">
        <MainFooter />
        <main className="min-h-screen">{children}</main>
        <LulNavbar pageContentData={pageContentDataToUse} />
        {/* {hideAnnouncementBanner ? null : (
          <AnnouncementBanner
            href={`https://joinleland.typeform.com/to/ehK1Nxt0?utm_source=banner&utm_medium=site`}
            text={
              <>
                Sign Up for 50% Off Live Courses for GMAT, GRE, LSAT, ACT, SAT,
                TOEFL
              </>
            }
            until={FIFTY_PERCENT_OFF_PROMOTION_DATE}
            dismissable
          />
        )} */}
      </div>
    </>
  );
};

export default Layout;
